module.exports = __webpack_public_path__ + "img/googlePlayBg.252f43da.png";